import * as React from "react";
import Svg, { G, Path, Defs, ClipPath, Rect } from "react-native-svg";
const SVGComponent = (props : any) => (
  <Svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#clip0_997_4779)">
      <Path
        opacity={0.2}
        d="M3.75 16.25H1.25C1.08424 16.25 0.925268 16.1842 0.808058 16.0669C0.690848 15.9497 0.625 15.7908 0.625 15.625V12.5C0.625 12.3342 0.690848 12.1753 0.808058 12.0581C0.925268 11.9408 1.08424 11.875 1.25 11.875H3.75V16.25Z"
        fill="#0E8741"
      />
      <Path
        opacity={0.2}
        d="M15.9377 4.37475C15.6134 4.37495 15.2931 4.44727 15.0002 4.58647C14.9789 4.11731 14.8072 3.66744 14.5105 3.30342C14.2137 2.93939 13.8077 2.68053 13.3525 2.56512C12.8972 2.44971 12.4169 2.48389 11.9826 2.66259C11.5483 2.84128 11.183 3.15502 10.9408 3.55739C10.6986 3.95977 10.5923 4.42941 10.6377 4.89686C10.683 5.36431 10.8776 5.80475 11.1927 6.15304C11.5078 6.50132 11.9266 6.73896 12.3871 6.83081C12.8477 6.92266 13.3256 6.86383 13.7502 6.66303C13.7699 7.09084 13.9148 7.50344 14.1668 7.84967C14.4189 8.1959 14.767 8.46054 15.1681 8.61076C15.5691 8.76098 16.0054 8.79018 16.4229 8.69473C16.8404 8.59929 17.2207 8.3834 17.5166 8.07384C17.8125 7.76427 18.0111 7.37466 18.0876 6.9533C18.1642 6.53194 18.1154 6.09738 17.9473 5.7035C17.7791 5.30963 17.4991 4.97376 17.1419 4.73756C16.7847 4.50136 16.366 4.37521 15.9377 4.37475Z"
        fill="#0E8741"
      />
      <Path
        d="M15.9375 8.75C17.1456 8.75 18.125 7.77062 18.125 6.5625C18.125 5.35438 17.1456 4.375 15.9375 4.375C14.7294 4.375 13.75 5.35438 13.75 6.5625C13.75 7.77062 14.7294 8.75 15.9375 8.75Z"
        stroke="#0E8741"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M3.75 16.25H1.25C1.08424 16.25 0.925268 16.1842 0.808058 16.0669C0.690848 15.9497 0.625 15.7908 0.625 15.625V12.5C0.625 12.3342 0.690848 12.1753 0.808058 12.0581C0.925268 11.9408 1.08424 11.875 1.25 11.875H3.75"
        stroke="#0E8741"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M8.75 12.5H11.25L16.4844 11.2961C16.6768 11.2434 16.8788 11.2357 17.0747 11.2738C17.2706 11.3118 17.4551 11.3945 17.6138 11.5154C17.7725 11.6363 17.9012 11.7922 17.9899 11.971C18.0785 12.1498 18.1248 12.3466 18.125 12.5461C18.1251 12.787 18.058 13.0232 17.9314 13.2281C17.8047 13.4331 17.6234 13.5986 17.4078 13.7063L14.375 15L9.375 16.25H3.75V11.875L5.70312 9.92188C5.8777 9.74791 6.08485 9.61007 6.31275 9.51623C6.54064 9.42239 6.78479 9.3744 7.03125 9.37501H10.9375C11.3519 9.37501 11.7493 9.53963 12.0424 9.83265C12.3354 10.1257 12.5 10.5231 12.5 10.9375C12.5 11.3519 12.3354 11.7493 12.0424 12.0424C11.7493 12.3354 11.3519 12.5 10.9375 12.5H8.75Z"
        stroke="#0E8741"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M13.7502 6.66303C13.3256 6.86383 12.8477 6.92266 12.3871 6.83081C11.9266 6.73896 11.5078 6.50132 11.1927 6.15304C10.8776 5.80475 10.683 5.36431 10.6377 4.89686C10.5923 4.42941 10.6986 3.95977 10.9408 3.55739C11.183 3.15502 11.5483 2.84128 11.9826 2.66259C12.4169 2.48389 12.8972 2.44971 13.3525 2.56512C13.8077 2.68053 14.2137 2.93939 14.5105 3.30342C14.8072 3.66744 14.9789 4.11731 15.0002 4.58647"
        stroke="#0E8741"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_997_4779">
        <Rect width={20} height={20} fill="white" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
